import Image from 'next/image';
import useTranslation from 'next-translate/useTranslation';
import { TechnicalContent } from '@/models/cropProblems';
import Caption from '../Caption';
import Paragraph, { VARIANT } from '../Paragraph';
interface Props {
  content: TechnicalContent;
  unit: string;
  quantity: number;
}
interface CaptionWithParaProps {
  label: string;
  value: string;
  marginTop?: number;
}
const CaptionWithPara = ({
  label,
  value,
  marginTop = 0
}: CaptionWithParaProps) => {
  return <>
      <Caption label={label} className={`text-neutral-50 mb-0.5 mt-${marginTop}`} data-sentry-element="Caption" data-sentry-source-file="ProductCard.tsx" />
      <Paragraph variant={VARIANT.MEDIUM} isHighlighted data-sentry-element="Paragraph" data-sentry-source-file="ProductCard.tsx">
        {value}
      </Paragraph>
    </>;
};
const ProductCard = ({
  content,
  quantity,
  unit
}: Props) => {
  const {
    t
  } = useTranslation('cropGuide');
  const {
    products,
    method
  } = content;
  const {
    company,
    name
  } = products[0];
  return <div className="bg-white p-4 border border-neutral-20 rounded-2xl mt-2 max-w-sm" data-sentry-component="ProductCard" data-sentry-source-file="ProductCard.tsx">
      <div className="flex gap-5 border-b border-neutral-20 pb-4">
        <div className="bg-neutral-10 w-24 h-24 rounded-lg">
          <Image src={products[0].image || ''} alt={name} width={96} height={96} className="max-h-full max-w-full rounded-lg" data-sentry-element="Image" data-sentry-source-file="ProductCard.tsx" />
        </div>

        <div>
          <CaptionWithPara label={company.name || ''} value={name} data-sentry-element="CaptionWithPara" data-sentry-source-file="ProductCard.tsx" />
        </div>
      </div>

      <CaptionWithPara label={t('chemical_name')} value={content.name} marginTop={3} data-sentry-element="CaptionWithPara" data-sentry-source-file="ProductCard.tsx" />
      <CaptionWithPara label={t('quantity')} value={`${quantity} ${unit}`} marginTop={3} data-sentry-element="CaptionWithPara" data-sentry-source-file="ProductCard.tsx" />
      <CaptionWithPara label={t('method')} value={method} marginTop={3} data-sentry-element="CaptionWithPara" data-sentry-source-file="ProductCard.tsx" />
    </div>;
};
export default ProductCard;